/**
 * The printed language of a worksheet (ADR 0051 §7). Shared here so every
 * generator, `Labels.ts` and the shared PDF chrome import one type rather than
 * repeating the literal union - the value itself still lives on
 * `ISettingsProps.Language` and travels through `generateUrl`/`ProcessUrl`.
 *
 * Not the interface locale (`src/Shared/i18n/Locale.ts`). See ADR 0051 §6/§7
 * for why the two are deliberately kept apart.
 */
export type PrintedLanguage = 'en' | 'es' | 'fr';

export const PRINTED_LANGUAGES: readonly PrintedLanguage[] = ['en', 'es', 'fr'];

/** `settings.Language`, defaulted to English the same way every reader here does. */
export function printedLanguageOf(settings: { Language?: string }): PrintedLanguage {
    return settings.Language === 'es' || settings.Language === 'fr' ? settings.Language : 'en';
}
